module.exports = __webpack_public_path__ + "static/media/21ECLAC12.a031d6bd.jpg";